import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, FormControl, TextField, Avatar, Divider, Stack } from '@mui/material'
import login_back_img from '../../../asset/login_back_img.png'
import Ellipse1 from '../../../asset/Ellipse1.png'
import Ellipse2 from '../../../asset/Ellipse2.png'
import { styled } from '@mui/system'
import logo from '../../../asset/logo_login.png'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined'
import Api from '../../../Api/Api'
import secureLocalStorage from 'react-secure-storage'
import mainLogoBig from '../../../asset/mainLogo_big.png'
import dayjs from 'dayjs'
import { useMediaQuery } from '@mui/material'

const InputTextField = styled(TextField)({
  '& label': {
    // placeholder text color
    color: '#BCBDC4',
  },
  '& label.Mui-focused': {
    // 해당 input focus 되었을 때 placeholder text color
    // floatng label을 사용할 때 처리 필요하다
    color: '#BCBDC4',
  },

  '& label.Mui-error': {
    color: '#d32f2f',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ffffff',
    borderWidth: '0.15rem',
  },
  '& .MuiOutlinedInput-root': {
    color: '#ffffff',
    '& fieldset': {
      borderColor: '#BCBDC4',
    },
  },
  '&:hover .MuiInputBase-input': {
    borderColor: '#afafaf',
    borderWidth: '1px',
    opacity: 0.8,
  },
  '&.Mui-focused .MuiInputBase-input': {
    borderColor: '#afafaf',
    borderWidth: '1px',
  },
  '& .MuiInputBase-input': {
    fontSize: '13px',
  },
})

export default function LoginPage() {
  const [inputId, setInputId] = useState('')
  const [inputPw, setInputPw] = useState('')

  const navigate = useNavigate()
  const onClickMain = () => {
    navigate('/')
  }
  const handleInputId = (e) => {
    setInputId(e.target.value)
  }

  const handleInputPw = (e) => {
    setInputPw(e.target.value)
  }
  const onClicRegister = () => {
    navigate('/User/Auth/Register')
  }
  const onKeyPress_1 = (e) => {
    if (e.key === 'Enter') {
      onClickLogin(e)
    }
  }

  // login 버튼 클릭 이벤트
  const onClickLogin = async (e) => {
    // e.preventDefault()

    //if (inputId.length >= 5 && inputId.length <= 12 && inputPw.length >= 9 && inputPw.length <= 20) {
    let loginParam = {
      username: inputId,
      password: inputPw,
    }

    try {
      const response = await Api.post('/api/v1/auth/login', loginParam)
      console.log('onClickLogin aduit response.data:', response.data)
      if (response.status === 200) {
        const now = dayjs().format('YYYY-MM-DD HH:mm:ss')
        const auditObject = {
          cdt: now,
          audit: inputId,
          sys: 'PORTAL',
          fc: '1000',
          tg: 'PORTAL',
        }
        const response2 = await Api.post('/api/v1/audit', auditObject)
        console.log('onClickLogin aduit response2.data:', response2.data)
        if (response2.status === 200) {
          secureLocalStorage.setItem('idx', response2.data.idx)
          secureLocalStorage.setItem('loginId', inputId)
          secureLocalStorage.setItem('access_token', response.data.access_token)
          secureLocalStorage.setItem('token_type', response.data.token_type)

          console.log('저장된 access_token:', secureLocalStorage.getItem('access_token'))
          console.log('저장된 loginId:', secureLocalStorage.getItem('loginId'))

          alert('로그인성공')
          navigate('/User/DashBoard/MainStats')
          window.location.reload()
        }
      }
    } catch (e) {
      alert('로그인실패 입니다.')
      // console.log(e.response.status);
    }
    //} 
    // else {
    //   alert('로그인실패 입니다.입력범위 오류입니다.')
    // }
  }

  const isMobile = useMediaQuery('(max-width:1023px)')
  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = 'hidden'
      document.body.style.height = '100svh'
    } else {
      document.body.style.overflow = ''
      document.body.style.height = ''
    }
  }, [isMobile])
  
  return (
    <div>
      {!isMobile && (
        <Box sx={{ flexGrow: 1 }}>
          <Grid container sx={{ margin: 5 }}>
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Stack
                direction="row"
                spacing={1}
                sx={{
                  alignItems: 'center',
                  alignContent: 'center',
                  justifyContent: 'center',
                  justifyItems: 'center',
                }}
              >
                <img style={{ marginTop: 3, height: 50, width: 50 }} src={mainLogoBig}></img>
                <Typography
                  sx={{
                    fontFamily: 'Monomaniac One',
                    fontSize: '48px',
                    fontWeight: 800,
                    lineHeight: '69.5px',
                    textAlign: 'left',
                    textUnderlinePosition: 'from-font',
                    textDecorationSkip: 'none',
                    color: '#ffffff',
                    marginLeft: 4,
                  }}
                >
                  BaRonM2M
                </Typography>
              </Stack>
            </Grid>
            <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
              <Typography
                sx={{
                  fontFamily: 'Noto Sans KR',
                  fontSize: '24px',
                  fontWeight: 400,
                  lineHeight: '34.75px',
                  textAlign: 'left',
                  textUnderlinePosition: 'from-font',
                  textDecorationSkip: 'none',
                  color: '#ffffff',
                  marginLeft: 4,
                }}
              >
                지능형산업안전관리플랫폼
              </Typography>
            </Grid>
            <Grid size={12}>
              <Grid container>
                <Grid size={7}>
                  <div>
                    <Box sx={{ width: 1, marginTop: 20 }}>
                      <img style={{ maxWidth: '100%', height: 'auto', padding: 0, margin: 0 }} src={login_back_img}></img>
                    </Box>
                  </div>
                </Grid>
                <Grid size={4} sx={{ marginTop: 10 }}>
                  <div>
                    <img style={{ marginBottom: -90, display: 'flex' }} src={Ellipse1}></img>
                    <Box
                      sx={{
                        marginLeft: 3,
                        marginRight: 3,
                        backdropFilter: 'blur(53px)',
                        boxShadow: '-8px 4px 5px 0px #0000003d',
                        borderRadius: '10px',
                        border: '1px solid #AFAFAF',
                        background:
                          'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 5.98%, rgba(0, 0, 0, 0) 66.28%)',
                      }}
                    >
                      <Box sx={{ margin: 5 }}>
                        <Typography
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            fontFamily: 'Noto Sans',
                            fontSize: '36px',
                            fontWeight: 600,
                            lineHeight: '49.03px',
                            textAlign: 'left',
                            textUnderlinePosition: 'from-font',
                            textDecorationSkipInk: 'none',
                            color: '#FFFFFF',
                          }}
                        >
                          Login
                        </Typography>
                        <Typography
                          sx={{
                            marginTop: 0.5,
                            display: 'flex',
                            justifyContent: 'flex-start',
                            fontFamily: 'Noto Sans',
                            fontSize: '15px',
                            fontWeight: 500,
                            lineHeight: '21.79px',
                            textAlign: 'left',
                            textUnderlinePosition: 'from-font',
                            textDecorationSkipInk: 'none',
                            color: '#FFFFFF',
                          }}
                        >
                          아이디와 비밀번호를 입력해주세요
                        </Typography>
                        <InputTextField
                          placeholder="ID"
                          variant="outlined"
                          onChange={handleInputId}
                          sx={{ width: '100%', height: 54, borderRadius: 12, mt: 2 }}
                        />
                        <InputTextField
                          id="outlined-basic"
                          placeholder="PASSWORD"
                          variant="outlined"
                          type="password"
                          onChange={handleInputPw}
                          onKeyDown={(e) => onKeyPress_1(e)}
                          sx={{ width: '100%', height: 54, borderRadius: 12, mt: 2 }}
                        />
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                // defaultChecked
                                sx={{
                                  color: '#ffffff',
                                  '& + .MuiFormControlLabel-label': {
                                    color: '#ffffff',
                                    fontSize: '14px',
                                  },
                                  '&.Mui-checked': {
                                    color: 'linear-gradient(to left, #7CC1F3 0%, #D27EEF 100%)',
                                    // "&, & + .MuiFormControlLabel-label": {
                                    //   color: "red"
                                    // },
                                  },
                                }}
                              />
                            }
                            label="계정 기억하기"
                          />
                        </FormGroup>
                        <Button
                          variant="contained"
                          sx={{
                            marginTop: 2,
                            width: '100%',
                            fontSize: '20px',
                            background: 'linear-gradient(89.58deg, #628EFF 10%, #8740CD 57.32%, #580475 99.08%);',
                            fontFamily: 'Noto Sans',
                            fontWeight: 600,
                            lineHeight: '27.24px',
                          }}
                          onClick={onClickLogin}
                        >
                          로그인
                        </Button>
                        <Divider
                          align="center"
                          sx={{
                            marginTop: '30px',
                            py: 0,
                            opacity: '0.1',
                            width: '100%',
                            maxWidth: '100%',
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            backgroundColor: 'background.paper',
                          }}
                        />
                        {/* <Grid size={12}>
                          <Button onClick={(e) => onClicRegister(e)}>계정등록</Button>
                        </Grid> */}
                        <Typography
                          sx={{
                            color: '#ffffff',
                            marginTop: 5,
                            fontFamily: 'Noto Sans',
                            fontSize: '13px',
                            fontWeight: 500,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          Copyrightⓒ2024.Azwell All Rights Reserved.
                        </Typography>
                        {/* 로고 */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <img style={{ marginTop: 25, width: 155, height: 52 }} src={logo}></img>
                        </Box>
                      </Box>
                    </Box>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <img style={{ marginTop: -50 }} src={Ellipse2}></img>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid size={12}>
              <Grid container>
                <Grid size={12} sx={{ marginLeft: 5, marginBottom: 5, display: 'flex', justifyContent: 'flex-start' }}>
                  <Stack>
                    {' '}
                    <Button onClick={() => onClickMain()}>
                      <ArrowCircleLeftOutlinedIcon sx={{ width: 54, height: 54, color: '#A2A2A8' }} />
                    </Button>
                    <Typography
                      sx={{
                        color: '#A2A2A8',
                        fontFamily: 'Noto Sans',
                        fontSize: '15px',
                        fontWeight: 600,
                      }}
                    >
                      뒤로 돌아가기
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Grid> */}
          </Grid>
        </Box>
      )}

      {/* 모바일 전용 코드 */}
      {isMobile && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            minWidth: 354,
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            px: 2,
            pt: 4,
            pb: 4,
            boxSizing: 'border-box',
          }}
        >
          {/* 로고 + 타이틀 */}
          <Stack direction="row" spacing={1} alignItems="center" mb={0}>
            <img style={{ height: 50, width: 50 }} src={mainLogoBig} alt="logo" />
            <Typography
              sx={{
                fontFamily: 'Monomaniac One',
                fontSize: '35px',
                fontWeight: 800,
                color: '#ffffff',
              }}
            >
              BaRonM2M
            </Typography>
          </Stack>

          <Typography
            sx={{
              fontFamily: 'Noto Sans KR',
              fontSize: '17px',
              fontWeight: 400,
              color: '#ffffff',
              mb: 2,
            }}
          >
            지능형산업안전관리플랫폼
          </Typography>

          {/* 로그인 박스 */}
          <Box
            sx={{
              width: '100%',
              maxWidth: 400,
              backdropFilter: 'blur(53px)',
              boxShadow: '-8px 4px 5px 0px #0000003d',
              borderRadius: '10px',
              border: '1px solid #AFAFAF',
              background:
                'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 5.98%, rgba(0, 0, 0, 0) 66.28%)',
              p: 4,
              mt: 1.5,
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Noto Sans',
                fontSize: '28px',
                fontWeight: 600,
                color: '#FFFFFF',
                mb: 0.5,
              }}
            >
              Login
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Noto Sans',
                fontSize: '13px',
                color: '#FFFFFF',
                mb: 2,
              }}
            >
              아이디와 비밀번호를 입력해주세요
            </Typography>

            <InputTextField
              placeholder="ID"
              variant="outlined"
              onChange={handleInputId}
              sx={{ width: '100%', height: 54, borderRadius: 2, mt: 2 }}
            />
            <InputTextField
              placeholder="PASSWORD"
              type="password"
              variant="outlined"
              onChange={handleInputPw}
              onKeyDown={onKeyPress_1}
              sx={{ width: '100%', height: 54, borderRadius: 2, mt: 1 }}
            />

            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{
                      color: '#ffffff',
                      '& + .MuiFormControlLabel-label': {
                        color: '#ffffff',
                        fontSize: '13px',
                      },
                      '&.Mui-checked': {
                        color: '#8740CD',
                      },
                      height: 40,
                    }}
                  />
                }
                label="계정 기억하기"
              />
            </FormGroup>

            <Button
              variant="contained"
              sx={{
                mt: 3,
                width: '100%',
                height: 45,
                fontSize: '17px',
                background: 'linear-gradient(89.58deg, #628EFF 10%, #8740CD 57.32%, #580475 99.08%)',
                fontFamily: 'Noto Sans',
                fontWeight: 500,
              }}
              onClick={onClickLogin}
            >
              로그인
            </Button>

            <Typography
              sx={{
                color: '#ffffff',
                mt: 4,
                fontFamily: 'Noto Sans',
                fontSize: '12px',
                fontWeight: 500,
                textAlign: 'center',
              }}
            >
              Copyrightⓒ2024.Azwell All Rights Reserved.
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 3 }}>
              <img style={{ width: 150, height: 50 }} src={logo} alt="azwell-logo" />
            </Box>
          </Box>
        </Box>
      )}

    </div>
  )
}
